export default {
  allUsers: 'All users',
  zeroUsers: '0 users are selected',
  users: 'users',
};
